const storeToken = (value) => {
  if (value) {
    localStorage.setItem('token', value)
  }
}

const getToken = () => {
  const token = localStorage.getItem('token')
  return token 
}

const storeRefresh = (value) => {
  if (value) {
    localStorage.setItem('refresh', value)
  }
}

const getRefresh = () => {
  const refresh = localStorage.getItem('refresh')
  return refresh 
}

const setLastActivity = () => {
  localStorage.setItem('lastActivity', Date.now().toString());
};

const getLastActivity = () => {
  const value = localStorage.getItem('lastActivity');
  return value ? parseInt(value, 10) : null;
};

const removeToken = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
  localStorage.removeItem('email')
  localStorage.removeItem('permission')
  localStorage.removeItem('session')
  localStorage.removeItem('refresh')
  localStorage.removeItem('lastActivity')
}

const storeUsername = (value) => {
  if (value) {
    localStorage.setItem('username', value)
  }
}

const getUsername = () => {
  const username = localStorage.getItem('username')
  return username 
}

const storeEmail = (value) => {
  if (value) {
    localStorage.setItem('email', value)
  }
}

const getEmail = () => {
  const email = localStorage.getItem('email')
  return email 
}

const storeAdmin = (value) => {
  if (value) {
    localStorage.setItem('permission', value)
  }
}

const getAdmin = () => {
  const email = localStorage.getItem('permission')
  return email 
}

const storeSession = (value) => {
  if (value) {
    localStorage.setItem('session', value)
  }
}

const getSession = () => {
  const session = localStorage.getItem('session')
  return session 
}


const removeSession = () => {
  localStorage.removeItem('session')
}

export { storeToken, getToken, removeToken, storeUsername, getUsername, storeEmail, getEmail, storeAdmin, getAdmin, storeSession, getSession, removeSession, storeRefresh, getRefresh, setLastActivity, getLastActivity}